'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { usePersistedState } from '@/shared/hooks/usePersistedState.mjs';

/**
 * Cookie-backed two-value sort preference. Wraps `usePersistedState` and
 * returns `[value, toggle]`, where `toggle` flips between the two values
 * `a` and `b`.
 *
 * @param {string} key - Cookie key for the persisted preference.
 * @param {string} initial - Server-read initial value (forwarded as a prop).
 * @param {[string, string]} pair - The two values to toggle between.
 * @returns {[string, () => void]}
 */
export function useToggleSort(key, initial, t0) {
  const $ = _c(8);
  const [a, b] = t0;
  const [value, setValue] = usePersistedState(key, initial);
  let t1;
  if ($[0] !== a || $[1] !== b || $[2] !== setValue || $[3] !== value) {
    t1 = () => {
      setValue(value === a ? b : a);
    };
    $[0] = a;
    $[1] = b;
    $[2] = setValue;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const toggle = t1;
  let t2;
  if ($[5] !== toggle || $[6] !== value) {
    t2 = [value, toggle];
    $[5] = toggle;
    $[6] = value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}